import RegisterCard from 'pages/life/registration/RegisterCard';
import './style.less';
import { useLocation, useNavigate } from 'react-router-dom';
import { StyledTitle } from 'components/StyledTitle';
import { Button, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
// import { useEffect } from 'react';
// import jwtDecode from 'jwt-decode';
// import { useKeycloakReady } from 'hooks';
// import { osName, osVersion } from 'react-device-detect';
type LifeCardPropList = {
  color?: string;
  arrow?: true;
  stateCode?: string;
  policynumber?: string;
  title?: string;
  name?: string;
  policyTitle?: string;
  alertsType?: string;
  alertsCode?: string;
  dueDate?: string;
  productCategory?: string;
  productCategoryUrl?: string;
  productCategoryEn?: string;
  productCategoryTC?: string;
  companyCode?: string;
  productName?: string;
  productNameTc?: string;
  policyStatusCode?: string;
  policyStatus?: string;
  policyStatusTc?: string;
  colour?: string;
  alertStateCode?: string;
  alertState?: string;
  alertStateTc?: string;
  policyNumber?: string;
  insuredName?: string;
  premiumDueDate?: string;
  salesUnitCode?: string;
  memberId?: string;
  effectiveStart?: string;
  effectiveEnd?: string;
}[];
interface LocationState {
  lifeCardData: LifeCardPropList;
  life: boolean;
  username: string;
  password: string;
}
export const AddConfirm = () => {
  const location = useLocation();
  const { life, lifeCardData } = (location.state as LocationState) ?? {};
  const { t } = useTranslation();
  // const { tokenParsed } = useKeycloakReady();
  const navigate = useNavigate();
  // useEffect(() => {
  //   console.log(location.state, 'location.state----------');
  // }, [life, lifeCardData, location.state]);
  const done = () => {
    // done
    if (location.pathname === '/addConfirmEb') {
      navigate('/home', { replace: true });
    } else {
      navigate('/LIHome', { replace: true });
    }
  };
  return (
    <div className="add_confirm_wrapper">
      <h3 className="policy-add">{t('life.register.PolicyAdded')}</h3>
      <div className="add_confirm_content">
        <h2 className="confirmEB">{t('life.register.ConfirmEBTitle1')}</h2>
        <h3 className="success">{t('registration.success2')}</h3>
        <div className="card_wrapper">
          <StyledTitle className="titlq" level={4}>
            {life ? t('registration.title1') : t('registration.title2')}
          </StyledTitle>
          <Divider />
          <RegisterCard data={lifeCardData} isLife={life ? true : false} />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            // backgroundColor: 'pink',
          }}
          className="form_btn"
        >
          <Button
            block
            className="btn"
            type="primary"
            size="large"
            style={{ marginTop: '20px', width: '80%', fontFamily: 'Roboto500', fontSize: '20px' }}
            // onClick={() => navigate('/ebRegist')}
            onClick={done}
          >
            {t('common.done')}
          </Button>
        </div>
      </div>
    </div>
  );
};
